
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h20v26H5V3zm2 2v22h16V5H7zm5 6h4c2.21 0 4 1.79 4 4s-1.79 4-4 4c-.74 0-1.406-.244-2-.594V22h-2v-7h2c0 1.19.81 2 2 2s2-.81 2-2-.81-2-2-2h-4v-2z"}})])
          )
        }
      }
    